import { useEffect, useState } from "react";

/**
 * Hook to force desktop viewport on mobile/tablet screens.
 * Returns prompt state — the consuming component decides what UI to show.
 *
 * Usage:
 *   const { showPrompt, accept, dismiss } = useDesktopMode();
 */
export const useDesktopMode = (breakpoint = 1024) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [desktopModeEnabled, setDesktopModeEnabled] = useState(false);

  // Detect mobile on mount
  useEffect(() => {
    const isMobile = window.innerWidth < breakpoint;
    if (isMobile) {
      setShowPrompt(true);
    } else {
      setDesktopModeEnabled(true);
    }
  }, [breakpoint]);

  // Apply desktop viewport when accepted
  useEffect(() => {
    if (!desktopModeEnabled) return undefined;
    const viewport = document.querySelector('meta[name="viewport"]');
    const originalContent = viewport?.getAttribute("content") || "";
    viewport?.setAttribute("content", `width=${breakpoint}`);
    return () => {
      viewport?.setAttribute("content", originalContent);
    };
  }, [desktopModeEnabled, breakpoint]);

  const accept = () => {
    setShowPrompt(false);
    setDesktopModeEnabled(true);
  };

  const dismiss = () => {
    setShowPrompt(false);
  };

  return { showPrompt, accept, dismiss };
};
